import React from 'react';
import T from 'prop-types';

const ShowMoreRow = ({ count, unit, onClick }) => (
  <tr className="b-t b-b">
    <td className="b-l b-r py-xxxs text-xxs-center trigger-show-more" colSpan="9">
      <button type="button" className="btn btn-link p-a-0 text-12" onClick={onClick}>
        <i className="hicon-plus-circle" />
        &nbsp;Show (<span className="x">{count}</span>) more <span className="text">{unit}</span>
        &hellip;
      </button>
    </td>
  </tr>
);

ShowMoreRow.propTypes = {
  count: T.number.isRequired,
  unit: T.string.isRequired,
  onClick: T.func.isRequired,
};

export default ShowMoreRow;
